import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";

function AppWebReportTaetigksberichtGeraete(props) {

    const [geraeteData, setGeraeteData] = useState([]);

    useEffect(() => {
        if(props.geraeteData===undefined){
            setGeraeteData([]);
        }
        else{
            setGeraeteData(props.geraeteData)
        }
    }, [props.geraeteData]);


    function getGeraeteTableBody(geraeteData) {
        return geraeteData?.map((item) => (<tr key={item.id}>
            <td>{item.name}</td>
        </tr>));
    }

    return (<>
        <Row>
            <Col>
                <label className="handwai-text-label-main add-bottom-0-margin">{"Betriebsmittel"}</label>
            </Col>

        </Row>
        <br/>
        <table id="geraeteTable" className="table handwai-white-text">
            <thead>
            <tr>
                <th>Bezeichnung</th>
            </tr>
            </thead>
            <tbody>{getGeraeteTableBody(geraeteData)}</tbody>
        </table>
    </>);
}

export default AppWebReportTaetigksberichtGeraete;
